import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { METHOD_STEPS } from "@/content/site";
import { Eyebrow, Reveal } from "@/components/site/Reveal";

// A journey, not four cards: one thin line runs down the page and fills as you scroll past each stage.
const Method = () => {
  const ref = useRef(null);
  const reduced = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.7", "end 0.6"] });
  const scaleY = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <section id="method" className="py-32 md:py-48" data-testid="method" aria-labelledby="method-heading">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <Reveal><Eyebrow>How we work</Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h2 id="method-heading" className="mt-7 font-display uppercase text-4xl sm:text-5xl lg:text-7xl tracking-tight leading-[0.95] text-[#2E1B16]">
              Everything builds on<br />
              <span className="font-accent font-normal normal-case text-[#38BDF8] text-[1.1em]">the step before it.</span>
            </h2>
          </Reveal>
        </div>

        <div ref={ref} className="relative mt-24 md:mt-32">
          <div className="absolute left-[18px] md:left-1/2 top-0 bottom-0 w-px bg-[#2E1B16]/12 md:-translate-x-1/2" aria-hidden="true">
            <motion.div style={{ scaleY: reduced ? 1 : scaleY }} className="absolute inset-0 origin-top bg-[#38BDF8]" />
          </div>

          <ol className="space-y-24 md:space-y-40">
            {METHOD_STEPS.map((s, i) => {
              const right = i % 2 === 1;
              return (
                <li key={s.n} className="relative grid md:grid-cols-2 gap-8 md:gap-24 pl-14 md:pl-0" data-testid={`method-step-${s.n}`}>
                  <span className="absolute left-[12px] md:left-1/2 top-3 w-3.5 h-3.5 rounded-full bg-[#FAF7F2] border-2 border-[#2E1B16] md:-translate-x-1/2" aria-hidden="true" />
                  <Reveal className={right ? "md:col-start-2 md:pl-16" : "md:pr-16 md:text-right"} y={36}>
                    <span className="font-display text-7xl md:text-8xl lg:text-9xl leading-none text-[#2E1B16]/10 select-none">{s.n}</span>
                    <h3 className="-mt-6 md:-mt-8 font-display uppercase text-3xl md:text-5xl tracking-tight text-[#2E1B16]">{s.title}</h3>
                    <p className="mt-5 text-lg md:text-xl text-[#2E1B16]/65 leading-relaxed max-w-md md:ml-auto md:mr-0" style={right ? { marginLeft: 0 } : undefined}>{s.body}</p>
                  </Reveal>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default Method;
